import { DASHBOARD_EVENTS, SYSTEM_TAB_IDS, USE_YN } from '../../shared/config/system.config';
import { setItem, removeItem } from '@/shared/utils/storage';

export const navigateToAddPage = (): void => {
    removeItem('COMMON_CODE_EDIT_MODE');
    window.dispatchEvent(new CustomEvent(DASHBOARD_EVENTS.NAVIGATE, {
        detail: { page: SYSTEM_TAB_IDS.COMMON_CODE_ADD },
    }));
};

export const navigateToEditPage = (grpCode: string): void => {
    setItem('COMMON_CODE_EDIT_GRP_CODE', grpCode);
    setItem('COMMON_CODE_EDIT_MODE', 'true');
    window.dispatchEvent(new CustomEvent(DASHBOARD_EVENTS.NAVIGATE, {
        detail: { page: SYSTEM_TAB_IDS.COMMON_CODE_ADD },
    }));
};

export const getUseYnLabel = (useYn: string): string =>
    useYn === USE_YN.YES ? '사용' : '미사용';

export const getUseYnClassName = (useYn: string): string =>
    useYn === USE_YN.YES ? 'active' : 'inactive';

export const displayValue = (value: string | undefined | null): string =>
    value || '-';
